import { useGatedShowContent } from "@with-nx/hooks-n-helpers";
import { DesignedCard, ReusableSection, Rule } from "@with-nx/simple-ui/atoms";
import { Col, Row } from "antd";
import { Box } from "simple-effing-primitive-layout";

import GatedContentShareButton from "../gated-content/GatedContentShareButton";
import { LockedScenePreviews } from "./LockedScenePreviews";
import { ScenePreviewCard } from "./ScenePreviewCard";
import { WaitListFormContainer } from "./WaitListFormContainer";

export const ScenePreviews = ({
  scenes,
  curtainWarmer,
  showId,
  customTitle = null,
  showTitle = null,
  redirectionUrl = null,
}) => {
  const { blocked, restricted } = useGatedShowContent(showId);
  const previewIsLocked = blocked || restricted;

  const previews = scenes;

  if (!previews || previews.length === 0)
    return redirectionUrl ? undefined : (
      <WaitListFormContainer restricted={restricted} showId={showId} />
    );

  const renderCurtainWarmer = () => {
    if (!curtainWarmer) return undefined;

    return (
      <Col xs={24} sm={24} md={12} lg={8}>
        <DesignedCard
          size="16x9"
          video={previewIsLocked ? undefined : curtainWarmer.blob.signedUrl}
          pop={true}
          outside={{
            title: "Curtain Warmer",
          }}
        />
      </Col>
    );
  };

  const renderScenePreviews = ({
    onlyPreviews = null,
    beforeIndex = null,
    afterIndex = null,
  }) => {
    if (onlyPreviews) {
      return (
        <div className="container">
          <Row gutter={[36, 18]}>
            {renderCurtainWarmer()}

            {previews.map((scene, index) => {
              const calculatedIndex = curtainWarmer ? index + 1 : index;

              if (beforeIndex && calculatedIndex >= beforeIndex) {
                return null;
              }

              if (afterIndex && calculatedIndex <= afterIndex) {
                return null;
              }

              if (previewIsLocked && index > (curtainWarmer ? 10 : 11))
                return null;

              return (
                <ScenePreviewCard
                  key={scene.id}
                  scene={scene}
                  index={index}
                  locked={
                    curtainWarmer
                      ? index <= 4
                      : index <= 5
                      ? false
                      : previewIsLocked
                  }
                />
              );
            })}
          </Row>
        </div>
      );
    }

    return (
      <ReusableSection>
        <div className="container">
          <Box parse="mb:24">
            <Rule
              rule="hl"
              color="var(--font1)"
              display="flex"
              style={{ alignItems: "center" }}
            >
              Scene Previews
              {!previewIsLocked ? (
                <Box parse="ml:10">
                  <GatedContentShareButton />
                </Box>
              ) : undefined}
            </Rule>
          </Box>
        </div>

        <div className="container">
          <Row gutter={[36, 18]}>
            {renderCurtainWarmer()}

            {previews.map((scene, index) => {
              if (previewIsLocked && index > (curtainWarmer ? 10 : 11))
                return null;

              return (
                <ScenePreviewCard
                  key={scene.id}
                  scene={scene}
                  index={index}
                  locked={
                    curtainWarmer
                      ? index <= 4
                      : index <= 5
                      ? false
                      : previewIsLocked
                  }
                />
              );
            })}
          </Row>
        </div>
      </ReusableSection>
    );
  };

  const findAttachment = (scene, name: string) =>
    scene.attachments.find((attachment) => attachment.name === name)?.blob
      .signedUrl;

  const thumbnails = previews.map(
    (scene) =>
      findAttachment(scene, "watermarked_still_thumbnail") ||
      findAttachment(scene, "preview_still") ||
      findAttachment(scene, "still") ||
      findAttachment(scene, "thumbnail")
  );

  if (previewIsLocked) {
    return (
      <LockedScenePreviews
        customTitle={customTitle}
        showTitle={showTitle}
        thumbnails={thumbnails}
        restricted={restricted}
        render={renderScenePreviews}
        previewsCount={previews.length}
      />
    );
  }

  return renderScenePreviews({});
};
